export default {
  AUTOCHECK: 'A369',
  CAPITALONE: 'D52F',
  CARCHEX: '4FF6',
  EXPERIAN: 'DF45',
  WESTLAKE: 'W32D',
  LEAD_WITH_MY_WALLET: '719A',
  EMAIL_LEAD_WITH_MY_WALLET: '719E',
  LEAD_WITH_TEST_DRIVE: 'T98D',
  EMAIL_LEAD: '56CB',
  BAP_EMAIL_LEAD_WITH_MY_WALLET: '719E',
  PHONE_LEAD: 'CE23',
  BAP_PHONE_LEAD_MY_WALLET: '719P',
  PHONE_LEAD_WITH_MY_WALLET: '719P',
  CHAT_LEAD: '4C27',
  CHAT_LEAD_WITH_MY_WALLET: '719C',
  TEXT_LEAD: 'D507',
  TEXT_LEAD_WITH_MY_WALLET: '719T',
  SHARE_CAR: '512C',
  PHONE_LEAD_MOBILE: 'F757',
  CREDIT_APP: 'TDV1',
  PSX_MAKE_OFFER: 'PS10',
  PSX_TEST_DRIVE: 'V3NH',
  PSX_CHAT_SELLER: 'GS6F'
};